"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubmitOpeningMeterReadMutation = void 0;
var kapi_1 = require("../../../shared/api/kapi");
var submit_electricity_opening_meter_read_1 = require("../../../shared/api/kapi/v1/operations/meter-reads/__generated__/submit-electricity-opening-meter-read");
var submit_gas_opening_meter_read_1 = require("../../../shared/api/kapi/v1/operations/meter-reads/__generated__/submit-gas-opening-meter-read");
var mapping_1 = require("./mapping");
var useSubmitOpeningMeterReadMutation = function (_a) {
    var fuel = _a.fuel;
    var _b = __read((0, submit_electricity_opening_meter_read_1.useSubmitElectricityOpeningMeterReadMutation)({
        refetchQueries: [kapi_1.AccountOpeningMeterReadsDocument],
        awaitRefetchQueries: true,
    }), 2), kapiElecOpeningMutation = _b[0], kapiElecLoading = _b[1].loading;
    var _c = __read((0, submit_gas_opening_meter_read_1.useSubmitGasOpeningMeterReadMutation)({
        refetchQueries: [kapi_1.AccountOpeningMeterReadsDocument],
        awaitRefetchQueries: true,
    }), 2), kapiGasOpeningMutation = _c[0], kapiGasLoading = _c[1].loading;
    var handleMutation = function (data, _a) {
        var _b = _a === void 0 ? {} : _a, onCompleted = _b.onCompleted, onError = _b.onError;
        switch (data.fuel) {
            case 'electricity':
                return kapiElecOpeningMutation({
                    variables: {
                        input: (0, mapping_1.mapSubmitReadCXToKapiOpeningElectricity)(data),
                    },
                    onCompleted: function () {
                        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted();
                    },
                    onError: function () {
                        onError === null || onError === void 0 ? void 0 : onError();
                    },
                });
            case 'gas':
                return kapiGasOpeningMutation({
                    variables: {
                        input: (0, mapping_1.mapSubmitReadCXToKapiOpeningGas)(data),
                    },
                    onCompleted: function () {
                        onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted();
                    },
                    onError: function () {
                        onError === null || onError === void 0 ? void 0 : onError();
                    },
                });
        }
    };
    var kapiLoading = fuel === 'electricity' ? kapiElecLoading : kapiGasLoading;
    return {
        mutate: handleMutation,
        loading: kapiLoading,
    };
};
exports.useSubmitOpeningMeterReadMutation = useSubmitOpeningMeterReadMutation;
